import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=6312df54&"
import script from "./ApplicationForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports